import { Shift } from '../board/hours-presets';

/** A row of the hours tables, as the API returns it (docs/superpowers/specs/2026-10-21-scheduler-hours-design.md). */
export interface HoursRow {
  dayOfWeek?: number;
  workDate?: string;
  shiftNo: number;
  closed: boolean;
  startMin: number | null;
  endMin: number | null;
  closedReason?: string | null;
}

/** One day's hours, as saved: closed (with a reason) or its shifts. */
export interface DayHours {
  closed: boolean;
  closedReason: string | null;
  shifts: Shift[];
}

export interface HoursFitter {
  id: number;
  name: string;
  active: boolean;
  ownHours: boolean;
  pattern: HoursRow[];
  days: HoursRow[];
}

export interface HoursResponse {
  workshop: { pattern: HoursRow[]; days: HoursRow[] };
  fitters: HoursFitter[];
}

export interface HoursRange {
  from: string;
  to: string;
  weekdays: number[];
  action: 'closed' | 'open' | 'default';
  closedReason?: string;
  shifts?: Shift[];
  nextDayShifts?: Shift[];
  target: 'workshop' | 'fitters';
  fitterIds?: number[];
}

/** The rows of one day (dated rows, or that weekday of a usual week) as DayHours. */
export function toDayHours(rows: HoursRow[]): DayHours {
  const closedRow = rows.find((r) => r.closed);
  if (closedRow || !rows.length) {
    return { closed: true, closedReason: closedRow ? closedRow.closedReason || null : null, shifts: [] };
  }
  return {
    closed: false,
    closedReason: null,
    shifts: rows.map((r) => ({ startMin: r.startMin, endMin: r.endMin })).sort((a, b) => a.startMin - b.startMin),
  };
}
